import "./sentry"; // MUST be first so errors during other imports are captured
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress harmless Recharts "ResponsiveContainer width(-1)/height(-1)" warnings
// that fire on the first paint before the parent grid measures itself. The
// charts still render correctly on the second paint cycle.
const _origWarn = console.warn;
console.warn = (...args) => {
  const msg = typeof args[0] === "string" ? args[0] : "";
  if (msg.includes("width(-1) and height(-1)") || msg.includes("width(0) and height(0)")) return;
  _origWarn.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
